import { formatNumber } from 'App/utils';
import { Text } from 'recharts';

export const TickYAxis = ({ payload: { value }, width, x, y }: any) => (
  <Text textAnchor='end' width={width} x={x} y={y}>
    {`${formatNumber(value)} kg`}
  </Text>
);
